import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { notNullOrEmpty } from '../../utils/common';
import { BatteryLevelIcon } from '../icons';
import { LabelAndValue } from '../labelAndValue';
import { Level } from './types';

const useStyles = makeStyles({ name: 'EmobilityBatterySelectContent' })(theme => ({
	icon: {
		'&.small': {
			height: 'auto',
			fontSize: '48px',
			marginRight: '40px',
			marginTop: 4
		},
		'&.large': {
			height: 'auto',
			fontSize: '66px',
			marginRight: '32px'
		}
	},
	valueItem: {
		marginRight: 15,
		'&.large': {
			minWidth: 73,
			fontSize: '24px',
			lineHeight: '28px'
		},
		'&.small': {
			minWidth: 73,
			fontSize: '14px',
			lineHeight: '16px'
		},
		'&.small-wide': {
			minWidth: 129,
			fontSize: '14px',
			lineHeight: '16px'
		},
		'&:last-child': {
			marginRight: 0
		}
	},
	note: {
		fontSize: '12px',
		lineHeight: '16px',
		whiteSpace: 'normal',
		fontWeight: theme.typography.fontWeightLight,
		overflowWrap: 'anywhere',
		display: 'flex',
		minHeight: 28,
		alignItems: 'center'
	}
}));

export type EmobilityBatteryMenuItemContentProps = {
	level: Level;
	iconVariant: 'small' | 'large' | 'none';
	valueVariant: 'small' | 'small-wide' | 'large';
	labelCharging?: string;
	note?: string;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
};

export const EmobilityBatteryMenuItemContent: React.FC<EmobilityBatteryMenuItemContentProps> = (props) => {
	const { level, iconVariant, labelCharging, note, valueVariant } = props;
	const { classes: styles, cx } = useStyles(undefined, { props });

	return (
		<React.Fragment>
			{iconVariant !== 'none' &&
				<BatteryLevelIcon
					className={cx(styles.icon, iconVariant)}
					level={level}
					color='primary' />}
			<LabelAndValue
				data-test='value-item-level'
				classes={{ root: cx(styles.valueItem, valueVariant) }}
				value={level + ' %'}
				label={labelCharging} />
			{notNullOrEmpty(note) &&
				<span
					data-test='charging-note'
					className={styles.note}>
					{note}
				</span>}
		</React.Fragment>
	);
};
